import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(items: any[], searchText : string): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLocaleLowerCase();

    return items.filter(item => {
      if (item.data.first_name && item.data.first_name.toLocaleLowerCase().includes(searchText))
        return true;
      if (item.data.surname && item.data.surname.toLocaleLowerCase().includes(searchText))
        return true;
      if (item.data.email && item.data.email.toLocaleLowerCase().includes(searchText))
        return true;
      if (item.data.phone && item.data.phone.includes(searchText))
        return true;
      return false;
    });
  }

}
